import {createContext} from 'react';

import {useQueue} from '#hook';

import {ToastProviderProps, ToastProviderValues} from './ToastProvider.types';

const DEFAULT_VALUE = {
  addToast: () => undefined,
  length: 0,
  list: [],
  maxVisible: 1,
  removeToast: () => undefined,
  resetToasts: () => undefined,
} as ToastProviderValues;

export const ToastProviderContext = createContext(DEFAULT_VALUE);

/**
 * ToastProvider adds context values for setting and reading toasts from a
 * state array.
 */
export const ToastProvider = ({
  initialItems = [],
  maxLength = 3,
  maxVisible = 3,
  ...otherProps
}: ToastProviderProps) => {
  const [list, controls] = useQueue({initialItems, maxLength});

  return (
    <ToastProviderContext.Provider
      value={{
        addToast: controls.addToQueue,
        length: controls.length,
        list,
        maxVisible,
        removeToast: controls.removeFromQueue,
        resetToasts: controls.resetQueue,
      }}
      {...otherProps}
    />
  );
};
